export default __webpack_public_path__ + "0efb1c6.woff";